import { forwardRef } from 'react';

import { CheckboxProps } from '@types';

import Icon from '../icon/Icon';

import theme from '../../../themes/colors';

import './style.css';

const commonCheckboxStyles = `appearance-none border cursor-pointer rounded-md border-content checked:border-primary focus:ring-transparent disabled:cursor-default`;
const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      label,
      handleChange,
      checkboxStyle,
      labelStyle,
      disabled,
      className,
      htmlKey,
      isChecked,
      ...props
    },
    ref
  ) => (
    <div className={`flex flex-row items-center ${className || ''} `}>
      <label
        className={`relative mr-2 flex items-center ${
          disabled ? 'cursor-not-allowed' : 'cursor-pointer '
        } ${checkboxStyle}`}
      >
        <input
          className={`${commonCheckboxStyles} checkbox size-[18px]`}
          type="checkbox"
          ref={ref}
          onChange={(e) => {
            handleChange(e);
          }}
          id={htmlKey || (label as string)}
          disabled={disabled}
          checked={isChecked}
          {...props}
        />
        <Icon
          name="checkbox"
          fill={disabled ? theme.grey : theme.primary}
          size="none"
          className={`checkbox-icon size-4.5 absolute rounded-md ${
            isChecked ? 'opacity-100' : 'opacity-0'
          }`} // Adjusted opacity based on isChecked prop
        />
      </label>
      <label
        htmlFor={htmlKey || (label as string)}
        className={`${labelStyle} text-sm font-normal text-grey`}
      >
        {label}
      </label>
    </div>
  )
);

export default Checkbox;
